/* sugar:assets/highlight-background.js@2.0.0 */
/*
  Highlight Background — starts the one-shot tug or highlighter sweep when the
  highlighted words scroll into view.

  The block renders a marker (data-hb-pulse) inside its host, the nearest
  .sw-block; the words are that host's strong / em / u. Each word is watched
  once (data-hb-seen) and gets data-hb-live the first time it is mostly on
  screen, which the block's own style turns into the animation. The sweep
  takes as long as a hand would over the phrase: the script writes --hb-sweep
  on each word, 0.6s plus 22ms a character, kept between 0.9s and 3.5s, and
  the style reads it.

  A host that clones cards (the testimonial wall, Splide's loop) copies the
  seen and live words with them, so a clone would never play. Such a host
  strips data-hb-seen and data-hb-live from the copy and asks for a rescan of
  the copy alone: window.SugarHighlightBackground.init(copy), or a bubbling
  sugar:highlight:scan event dispatched on it. The marker is not in the copy;
  it sits on the grid or slider root above, so a scan that finds no marker
  inside its root walks up to the nearest .sw-block that owns one and watches
  the root's own words for it.
*/
(function () {
  'use strict';
  if (window.__sugarHighlightBackground) return;
  window.__sugarHighlightBackground = true;

  function selectorFor(tag) {
    if (tag === 'u') return '.sw-content u, .sw-content span[style*="underline"]';
    // A list (bold + italic in either nesting) scopes each of its parts
    return tag.split(',').map(function (t) { return '.sw-content ' + t.trim(); }).join(', ');
  }

  function sweepFor(word) {
    var chars = (word.textContent || '').trim().length;
    return Math.min(3.5, Math.max(0.9, 0.6 + 0.022 * chars)).toFixed(2) + 's';
  }

  var io = null;
  function observer() {
    if (io) return io;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.setAttribute('data-hb-live', '');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.6 });
    return io;
  }

  /* Watches each word once; a word already seen keeps whatever state it has. */
  function watch(words) {
    Array.prototype.forEach.call(words, function (word) {
      if (word.hasAttribute('data-hb-seen')) return;
      word.setAttribute('data-hb-seen', '');
      word.style.setProperty('--hb-sweep', sweepFor(word));
      if ('IntersectionObserver' in window) observer().observe(word);
      else word.setAttribute('data-hb-live', '');
    });
  }

  function wordsFor(marker, root) {
    return root.querySelectorAll(selectorFor(marker.dataset.hbTarget || 'strong'));
  }

  function arm(marker) {
    if (marker.dataset.hbDone) return;
    marker.dataset.hbDone = '1';
    var host = marker.closest('.sw-block');
    if (host) watch(wordsFor(marker, host));
  }

  /* The markers a host owns: those inside it whose nearest .sw-block is the
     host itself and not a text block nested in it. */
  function ownMarkers(host) {
    return Array.prototype.filter.call(host.querySelectorAll('[data-hb-pulse]'), function (marker) {
      return marker.closest('.sw-block') === host;
    });
  }

  /* A copy with no marker of its own: the host above owns it, so watch the
     copy's words for each marker that host has. */
  function armWithin(root) {
    var host = root.closest ? root.closest('.sw-block') : null;
    while (host) {
      var markers = ownMarkers(host);
      if (markers.length) {
        markers.forEach(function (marker) { watch(wordsFor(marker, root)); });
        return;
      }
      host = host.parentElement ? host.parentElement.closest('.sw-block') : null;
    }
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var markers = scope.querySelectorAll('[data-hb-pulse]');
    if (markers.length) markers.forEach(arm);
    else if (scope !== document) armWithin(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('sugar:highlight:scan', function (event) { init(event.target); });
  window.SugarHighlightBackground = { init: init };
})();
